export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/mezzopiano-icon.svg?30179c12e1b63d18f502f45f35ecef1d";